import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {SelectGroup} from 'components/Form/SelectGroup/SelectGroup';
import {SelectWrapper} from 'components/Form/SelectGroup/SelectWrapper';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Action} from 'redux';
import {ThunkDispatch} from 'redux-thunk';
import DateSelect from '../../../components/Form/DateSelect/DateSelect';
import NavigationBar from '../../../components/NavigationBar';
import {PageTitle} from '../../../components/PageTitle/PageTitle';
import {useUniversalTracking} from '../../../lib/tracking/universalTracking';
import {getDateComponent} from '../../../lib/utils';
import {colors} from '../../../theme/theme';
import {
	AppState,
	CarState,
	CollectedState,
	ContractState,
	FahrzeugType,
	KehButton,
	Produkt,
	SalesType,
	Zahlweise
} from '../../../types/redux';
import {toEnum} from '../../../utils/enum';
import {formatPriceDe, formatterPrice, formatVehicel} from "../../../utils/formatString";
import {GenericInput} from "../../../components/Form/GenericInput/GenericInput";
import {onPressEnterHandlerFactory, onSelectInputHandlerFactory} from "../../../utils/formInteraction";
import {GenericSelect} from "../../../components/Form/GenericSelect/GenericSelect";
import {LAUFZEIT_Array} from "../../../lib/constants";
import {calculateContract} from "../../../redux/actions/contractPrices";
import {Tariffing} from "../../../types/api";

interface DateParts {
	day?: string;
	month?: string;
	year?: string;
}
interface epkVehicleProps extends StateProps, DispatchProps {
	onSubmit(data: any): void;
}
const useStyles = makeStyles((theme: Theme) => ({
	subtitle: {
		marginBottom: theme.spacing(4),
	},
	sectionTitle: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(2),
	},
	generalErrorMessage: {
		color: colors.red,
		fontSize: 14,
		marginTop: theme.spacing(1),
		padding: theme.spacing(1, 1, 1, 0),
	},
	errorMessage: {
		color: colors.red,
		fontSize: 14,
		marginLeft: 0,
		marginTop: theme.spacing(1),
	},
	ep_vehicle_main: {
		// display: "grid",
		// gridTemplateColumns: "1fr 1fr",
		// gridTemplateRows: "1fr",
		display: "flex",
		flexWrap: "wrap",
		flexDirection: "column",
		// columnGap: "8em",
		// marginBottom: "6em"
	},
	ep_vehicle_container_firstChild: {
		flex: "0 0 auto",
	},
	ep_vehicle_container: {
		flex: "1 1 auto",
		display: "flex",
		columnGap: "2em",
		flexWrap: "wrap",
	},
	ep_vehicle_container_lastChild: {
		flex: "0 0 auto",
	},
	ep_vehicle_left: {
		display: "grid",
		gridTemplateRows: "14em auto",
		alignContent: "flex-start"
	},
	ep_vehicle_right: {
		display: "grid",
		gridTemplateRows: "14em auto",
		alignContent: "flex-start"
	},
 	ep_vehicle_box: {
	},
	'.user_data_selector_wrapper': {
		display: 'grid',
		//width: '24em',
		height: '56px',
		backgroundColor: 'white',
		marginRight: '24px',
		marginBottom: '10px',
		marginLeft: '0px'
	},
}));
const InternalepVehicle: React.FC<epkVehicleProps> = (props) => {

	const { t } = useTranslation();
	const { trackEvent } = useUniversalTracking();
	const classes = useStyles();
	const fTyp = (props.contract.neufahrzeug) ? CarState.NEW_CAR : props.contract.neufahrzeug;
	const [carState, setCarState] = React.useState<CarState>(fTyp || undefined as unknown as CarState );
	const [carTyp, setCarTyp] = React.useState<FahrzeugType>(props.contract.fahrzeugtyp || undefined as unknown as FahrzeugType);
	const [zahlweiseState, setZahlweiseState] = React.useState<Zahlweise>( props.contract.zahlweise as Zahlweise || undefined as unknown as Zahlweise );
	const [produkt, setProdukt] = React.useState<Produkt>(props.contract.produkt || Produkt.EPP);
	const [naviButton, setNaviButton] = React.useState( KehButton.CALC_NOW );
	const [isCalculated, setIsCalculated] = React.useState( false );
	const [beitrag, setBeitrag] = React.useState('' as string);
	const revertButtonState = ()=> {
		setNaviButton(KehButton.CALC_NOW);
		setIsCalculated(false);
		// props.collectedState.selectedButton = KehButton.CALC_NOW;
	}
	props.collectedState.selectedButton = naviButton;
	useEffect(
		() => {
			const selection = isCalculated ? KehButton.NOT_SELECTED : KehButton.CALC_NOW;
			setNaviButton(selection);
			props.collectedState.selectedButton = selection
		},
		// eslint-disable-next-line
		[isCalculated, naviButton, props.collectedState.selectedButton, beitrag]
	);
	const handleChangeIsNewCar = (event: React.ChangeEvent<HTMLInputElement>) => {
		const carStateEnum: CarState = toEnum(CarState, (event.target as HTMLInputElement).value as CarState) || CarState.NEW_CAR;
		setCarState(carStateEnum);
		validateKaufdatum({}, carStateEnum);
		revertButtonState();
	};
	const handleChangeCarTyp = (event: React.ChangeEvent<HTMLInputElement>) => {
		onSelectInput(event);
		const carTypEnum: FahrzeugType = toEnum(FahrzeugType, (event.target as HTMLInputElement).value as FahrzeugType) || FahrzeugType.P;
		setCarTyp(carTypEnum);
		revertButtonState();
	};
	const handleChangeZahlweise=(event: React.ChangeEvent<HTMLInputElement>) => {
		onSelectInput(event);
		const zahlweiseStateEnum: Zahlweise = toEnum(Zahlweise, (event.target as HTMLInputElement).value as Zahlweise) || Zahlweise.EB;
		setZahlweiseState(zahlweiseStateEnum);
		revertButtonState();
	};
	const handleChangeProdukte=(event: React.ChangeEvent<HTMLInputElement>) => {
		onSelectInput(event);
		const produktStateEnum: Produkt = toEnum(Produkt, (event.target as HTMLInputElement).value as Produkt) || Produkt.EP;
		setProdukt(produktStateEnum);
		revertButtonState();
	};

	const [kaufpreis, setKaufpreis] = useState(props.contract.kaufpreis || undefined as unknown as number);
	const [laufzeit, setLaufzeit] = useState(props.contract.laufzeit || undefined as unknown as number);
	const getLaufzeit = ()=>{
		const values: any[] = [];
		LAUFZEIT_Array.forEach( (i)=> values.push({ value: i, label: i } ));
		return values;
	}
	const getLaufzeitValues: any[] = getLaufzeit();

	const initialBuyDate = props.contract.kaufdatum ;//|| moment().format('YYYY-MM-DD');
	const [buyYear, setBuyYear] = useState( getDateComponent(initialBuyDate, 'year') );
	const [buyMonth, setBuyMonth] = useState( getDateComponent(initialBuyDate, 'month') );
	const [buyDay, setBuyDay] = useState(getDateComponent(initialBuyDate, 'day'));
	const [buyDateError, setBuyDateError] = useState('');

	const initialVersBeginDate = props.contract.beginndatum ;//|| moment().format('YYYY-MM-DD');
	const [versBeginYear, setVersBeginYear] = useState( getDateComponent(initialVersBeginDate, 'year') );
	const [versBeginMonth, setVersBeginMonth] = useState( getDateComponent(initialVersBeginDate, 'month') );
	const [versBeginDay, setVersBeginDay] = useState(getDateComponent(initialVersBeginDate, 'day'));
	const [versBeginDateError, setVersBeginDateError] = useState('');

	const kaufpreisRef = React.useRef<HTMLElement>(null);
	const laufzeitRef = React.useRef<HTMLElement>(null);
	const zahlweiseRef = React.useRef<HTMLElement>(null);
	const carStateRef = React.useRef<HTMLElement>(null);
	const carTypRef = React.useRef<HTMLElement>(null);
	const produktRef = React.useRef<HTMLElement>(null);
	const buyDayRef = React.useRef<HTMLElement>(null);
	const buyMonthRef = React.useRef<HTMLElement>(null);
	const buyYearRef = React.useRef<HTMLElement>(null);
	const versBeginDayRef = React.useRef<HTMLElement>(null);
	const versBeginMonthRef = React.useRef<HTMLElement>(null);
	const versBeginYearRef = React.useRef<HTMLElement>(null);

	const [kaufpreisError,		setKaufpreisError] = useState(undefined as unknown as string);
	const [laufzeitError,		setLaufzeitError] = useState(undefined as unknown as string);
	const [zahlweiseError,		setZahlweiseError] = useState(undefined);
	const [carStateError,		setCarStateError] = useState('');
	const [carTypeError,		setCarTypeError] = useState('');
	const [produktError,		setProduktError] = useState(undefined);
	const [buyDayError,			setBuyDayError] = useState(undefined);
	const [buyMonthError,		setBuyMonthError] = useState(undefined);
	const [buyYearError,		setBuyYearError] = useState(undefined);
	const [versBeginDayError,	setVersBeginDayError] = useState(undefined);
	const [versBeginMonthError,	setVersBeginMonthError] = useState(undefined);
	const [versBeginYearError,	setVersBeginYearError] = useState(undefined);

	const [generalError, setGeneralError] = useState('');

	const formRefs = [
		kaufpreisRef,
		laufzeitRef,
		zahlweiseRef,
		carStateRef,
		carTypRef,
		produktRef,
		buyDayRef,
		buyMonthRef,
		buyYearRef,
		versBeginDayRef,
		versBeginMonthRef,
		versBeginYearRef
	];

	useEffect(() => {
			validateSelectNotEmpty(kaufpreis, kaufpreisError, setKaufpreisError);
			validateKaufpreis();
		},
		// eslint-disable-next-line
		[kaufpreis]);
	useEffect(() => validateSelectNotEmpty(laufzeit, laufzeitError, setLaufzeitError),
		// eslint-disable-next-line
		[laufzeit]);
	useEffect(() => validateSelectNotEmpty(zahlweiseState, zahlweiseError, setZahlweiseError),
		// eslint-disable-next-line
		[zahlweiseState]);
	useEffect(() => validateSelectNotEmpty(carState, carStateError, setCarStateError),
		// eslint-disable-next-line
		[carState]);
	useEffect(() => validateSelectNotEmpty(carTyp, carTypeError, setCarTypeError),
		// eslint-disable-next-line
		[carTyp]);
	useEffect(() => validateSelectNotEmpty(produkt, produktError, setProduktError),
		// eslint-disable-next-line
		[produkt]);
	useEffect(() => validateSelectNotEmpty(buyDay, buyDayError, setBuyDayError),
		// eslint-disable-next-line
		[buyDay]);
	useEffect(() => validateSelectNotEmpty(buyMonth, buyMonthError, setBuyMonthError),
		// eslint-disable-next-line
		[buyMonth]);
	useEffect(() => validateSelectNotEmpty(buyYear, buyYearError, setBuyYearError),
		// eslint-disable-next-line
		[buyYear]);
	useEffect(() => validateSelectNotEmpty(versBeginDay, versBeginDayError, setVersBeginDayError),
		// eslint-disable-next-line
		[versBeginDay]);
	useEffect(() => validateSelectNotEmpty(versBeginMonth, versBeginMonthError, setVersBeginMonthError),
		// eslint-disable-next-line
		[versBeginMonth]);
	useEffect(() => validateSelectNotEmpty(versBeginYear, versBeginYearError, setVersBeginYearError),
		// eslint-disable-next-line
		[versBeginYear, versBeginYearRef]);

	const validateSelectNotEmpty = (
		value: any,
		valueError: string | undefined,
		setValueError: any,
		forceValidation: boolean = false
	) => {
		// Note: valueError === undefined will stop the validation from happening, we will start
		// validating as soon as length > 0 or an external function sets valueError !== undefined
		if (value === undefined) {
			setValueError(' ')
		} else  if (value !== '') {
			setValueError('');
		} else if (forceValidation || valueError !== undefined) {
			setValueError(' '); // Any non-blank string will highlight the select in red
		}
	};

	const validateNotEmpty = (
		value: string,
		valueError: string | undefined,
		setValueError: any,
		forceValidation: boolean = false
	) => {
		// Note: valueError === undefined will stop the validation from happening, we will start
		// validating as soon as length > 0 or an external function sets valueError !== undefined
		if (value.length > 0) {
			setValueError('');
		} else if (forceValidation || valueError !== undefined) {
			// TODO refactor
			// we have an error but don't want to show a message here because we have the general error message
			setValueError(' ');
		}
	};

	const validateKaufpreis = (
	): boolean =>{
		let error = '';
		if (kaufpreis === undefined ) {
			error = ' ';
		} else if (kaufpreis === 0) {
			error= t('epVehicle.errors.priceRange');
		} else if (! /^[1-9][0-9]{0,2}(?:\.?[0-9]{3}){0,3}(\.[0-9]{0,2})?$/g.test(kaufpreis.toString())) {
			error= t('epVehicle.errors.invalidNumber');
		} else if ( kaufpreis < 1000 || kaufpreis > 300000  ) {
			error= t('epVehicle.errors.priceRange');
		}
		setKaufpreisError(error)
		return error === '';
	}
	const validateKaufdatum = (
		date: DateParts = {},
		newCarState?: CarState
	): boolean => {
		const dateString = `${date.year || buyYear}-${date.month || buyMonth}-${
			date.day || buyDay
		}`;
		const buyDate = moment(dateString);
		const nowDate = moment();
		const cs = newCarState ?? carState;
		const beforeHalfYear= moment().subtract(12, 'months');

		let error = '';
		if (!buyDate.isValid()) {
			error = t('epVehicle.errors.invalidDate');
		} else if (
			// cs === CarState.NEW_CAR &&
			buyDate.isBefore(beforeHalfYear, 'days') ) {
			error = t('epVehicle.errors.buyDate');
		} else if (
			// cs === CarState.NEW_CAR &&
			buyDate.isAfter(nowDate, 'days') ) {
			error = t('epVehicle.errors.buyDate');
		}

		setBuyDateError(error);

		return error === '';
	};
	const validateVersBeginDate = (
		date: DateParts = {}
	): boolean => {
		const dateString = `${date.year || versBeginYear}-${date.month || versBeginMonth}-${
			date.day || versBeginDay
		}`;
		const versBeginDate = moment(dateString);
		const nowDate = moment();
		const inHalfYear= moment().add(12, 'months');
		let error = '';
		if (!versBeginDate.isValid()) {
			// invalid date
			error = t('epVehicle.errors.invalidDate');
		} else if (
			versBeginDate.isAfter(inHalfYear, 'days')
		) {
			error = t('epVehicle.errors.versBeginDate');
		} else if (
			versBeginDate.isBefore(nowDate, 'days')
		) {
			error = t('epVehicle.errors.versBeginDate');
		}
		setVersBeginDateError(error);
		return error === '';
	};
	const formIsValid = (): boolean => {
		const errors = [
			kaufpreisError,
			laufzeitError,
			zahlweiseError,
			carStateError,
			carTypeError,
			produktError,
			buyDayError,
			buyMonthError,
			buyYearError,
			versBeginDayError,
			versBeginMonthError,
			versBeginYearError,
		].filter((errMsg) => errMsg !== '');
		return errors.length === 0	 ;
	}
	const handleCalc = async ()=> {
		setBeitrag('')
		validateSelectNotEmpty(kaufpreis, kaufpreisError, setKaufpreisError, true)
		validateSelectNotEmpty(laufzeit, laufzeitError, setLaufzeitError, true)
		validateSelectNotEmpty(zahlweiseState, zahlweiseError, setZahlweiseError, true)
		validateSelectNotEmpty(carState, carStateError, setCarStateError, true)
		validateSelectNotEmpty(carTyp, carTypeError, setCarTypeError, true)
		validateNotEmpty(produkt, produktError, setProduktError, true)
		validateSelectNotEmpty(buyDay, buyDayError, setBuyDayError, true)
		validateSelectNotEmpty(buyMonth, buyMonthError, setBuyMonthError, true)
		validateSelectNotEmpty(buyYear, buyYearError, setBuyYearError, true)
		validateSelectNotEmpty(versBeginDay, versBeginDayError, setVersBeginDayError, true)
		validateSelectNotEmpty(versBeginMonth, versBeginMonthError, setVersBeginMonthError, true)
		validateSelectNotEmpty(versBeginYear, versBeginYearError, setVersBeginYearError, true)

		const notValid = !validateKaufdatum({}, carState)
			|| !validateVersBeginDate()
			|| !validateKaufpreis()
			|| !formIsValid();

		if (notValid) {
			setGeneralError('Bitte füllen Sie die Vertragsdaten vollständig aus.');
			setIsCalculated(false);
			setNaviButton( KehButton.CALC_NOW )
			return;
		}
		trackEvent({
			category: 'fahrzeug-calc',
			action: 'click-event',
			label: 'fahrzeug',
		});
		setGeneralError('')

		// set all state Vars, and dispatch
		props.contract.fahrzeugtyp = carTyp;
		props.contract.neufahrzeug = carState === CarState.NEW_CAR;
		props.contract.kaufdatum = `${buyYear}-${buyMonth}-${buyDay}`
		props.contract.kaufpreis = kaufpreis;
		props.contract.zahlweise = zahlweiseState;
		props.contract.laufzeit = laufzeit;
		props.contract.beginndatum = `${versBeginYear}-${versBeginMonth}-${versBeginDay}`
		props.contract.produkt = produkt;

		setNaviButton(KehButton.NOT_SELECTED);
		console.log(" ############### " +  versBeginYear)
		await props.calculate()
			.then((data) => {

				setIsCalculated(true);
				const price = formatPriceDe(data.beitrag) || "";
				setBeitrag(props.contract.zahlweise === Zahlweise.MB ? "Prämie: " + price + " € / Monat" : "Einmalbeitrag: " + price + " €");
			})
			.catch((errorMsg) => {
				setGeneralError('Tarifierung fehlgeschlagen: ' + errorMsg )
				setBeitrag('Tarifierung fehlgeschlagen')
				setIsCalculated(false);
			});
	}

	const validateAndSubmit = () => {
		if (formIsValid() && isCalculated	) {
			trackEvent({
				category: 'fahrzeug-submit',
				action: 'click-event',
				label: 'fahrzeug',
			});
			props.onSubmit({});
		}
	};

	// event listener on input field key press events to focus next input or submit form
	const onKeyPressEnter = onPressEnterHandlerFactory(
		formRefs,
		handleCalc
	);

	// event listener on select field input events to focus next input or submit form
	const onSelectInput = onSelectInputHandlerFactory(
		formRefs,
		handleCalc
	);
	const [editing, setEditing]  = useState(false);
	const toggleEditing = ()=>{
		setEditing(!editing);
	}

	const [inp, setInp] = useState(props.contract.kaufpreis || "");
	return (
		<div className={classes.ep_vehicle_main}>
			<div className={classes.ep_vehicle_container_firstChild}>
				<PageTitle title={t('epVehicle.title')} marginBottom={1} />
				{!!generalError && (
					<div className={classes.generalErrorMessage}>{generalError}</div>
				)}
			</div>
			<div className={classes.ep_vehicle_container}>
				<div className={classes.ep_vehicle_left}>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle} >
							{t('epVehicle.section_title')}
							{carTypeError !== '' && <FormLabel id="demo-error-radios" error={carTypeError !== ''}> bitte wählen</FormLabel>}
						</Typography>
						<FormControl required component="fieldset">
							<RadioGroup
								aria-labelledby="demo-error-radios"
								aria-label="Fahrzeugtyp"
								className="epeCarState"
								name="carTyp"
								value={carTyp}
								onChange={handleChangeCarTyp}
								ref={carTypRef}
							>
								<FormControlLabel
									value={FahrzeugType.P}
									control={<Radio color="primary" />}
									label={formatVehicel(FahrzeugType.P)}
								/>
								<FormControlLabel
									value={FahrzeugType.M}
									control={<Radio color="primary" />}
									label={formatVehicel(FahrzeugType.M)}
								/>
								<FormControlLabel
									value={FahrzeugType.W	}
									control={<Radio color="primary" />}
									label={formatVehicel(FahrzeugType.W)}
								/>
							</RadioGroup>
						</FormControl>
					</div>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle} id="Fahrzeugzustand">
							{t('epVehicle.section1_title')}
							{carStateError !== '' && <FormLabel id="demo-error-radios" error={carStateError !== ''}> bitte wählen</FormLabel>}
						</Typography>
						<FormControl required component="fieldset">
							<RadioGroup
								aria-labelledby="Fahrzeugzustand"
								aria-label="Fahrzeugzustand"
								className="epeCarState"
								name="carState"
								value={carState}
								onChange={handleChangeIsNewCar}
								ref={carStateRef}
							>
								<FormControlLabel
									value={CarState.NEW_CAR}
									control={<Radio color="primary" />}
									label="Neu"
								/>
								<FormControlLabel
									value={CarState.USED_CAR}
									control={<Radio color="primary" />}
									label="Gebraucht"
								/>
							</RadioGroup>
						</FormControl>
					</div>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle}>
							{t('epVehicle.section7_title')}
						</Typography>
						<div className={`${classes['.user_data_selector_wrapper']} ${classes['.user_data_input']}`}
						>
							<GenericInput
								label={""}
								inputId="ep_vehicle_kaufpreis"
								toggleEditing={toggleEditing}
								type={ editing ? "number" :  "text"}
								error={kaufpreisError}
								inputValue={
									( editing
									? (inp===0 ? '' : inp)
									: (kaufpreis===undefined || kaufpreis===0 ? '' : formatterPrice.format( kaufpreis ))
									) as any
								}
								setInputValue={ (value)=> {
									if(value !== '' || Number(value)!==0) {
										setKaufpreis(Number(value));
										setInp(value );
									}
									revertButtonState();
								}}
								additionalInputParams={ editing ? {
									inputRef: kaufpreisRef,
									onKeyPress: onKeyPressEnter,
									autoFocus: true,
								}:{
									onKeyPress: onKeyPressEnter,
									autoFocus: true,
								} }
							/>
						</div>
					</div>
					<div className={classes.ep_vehicle_box}>
							<Typography variant="h3" className={`${classes.sectionTitle} epeBuyDateTitle`} >
								{t('epVehicle.section2_title')}
							</Typography>
							<SelectGroup>
								<SelectWrapper>
									<DateSelect
										selectedValue={buyDay}
										setSelectedValue={(value) => {
											setBuyDay(value);
											validateKaufdatum({ day: value });
											revertButtonState();
										}}
										placeholder={t('common.date.day')}
										error={buyDayError}
										dataCy="buy_day"
										dateType="day"
										// defaultDate={moment().toDate()}
										additionalInputParams={{
											inputRef: buyDayRef,
											onInput: onSelectInput,
										}}
									/>
								</SelectWrapper>
								<SelectWrapper>
									<DateSelect
										selectedValue={buyMonth}
										setSelectedValue={(value) => {
											setBuyMonth(value);
											validateKaufdatum({ month: value });
											revertButtonState();
										}}
										placeholder={t('common.date.month')}
										error={buyMonthError}
										dataCy="buy_month"
										dateType="month"
										// defaultDate={moment().toDate()}
										additionalInputParams={{
											inputRef: buyMonthRef,
											onInput: onSelectInput,
										}}
									/>
								</SelectWrapper>
								<SelectWrapper>
									<DateSelect
										selectedValue={buyYear}
										setSelectedValue={(value) => {
											setBuyYear(value);
											validateKaufdatum({ year: value });
											revertButtonState();
										}}
										placeholder={t('common.date.year')}
										error={buyYearError}
										dataCy="buy_year"
										dateType="year"
										// defaultDate={moment().add(1, 'years').toDate()}
										additionalInputParams={{
											inputRef: buyYearRef,
											onInput: onSelectInput,
										}}
										onlyRange={true}
									/>
								</SelectWrapper>
							</SelectGroup>
							{!!buyDateError && (
								<div className={classes.errorMessage}>{buyDateError}</div>
							)}
						</div>
				</div>
				<div className={classes.ep_vehicle_right}>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle}>
							{t('epVehicle.section3_title')}
							{zahlweiseError !== '' && <FormLabel id="demo-error-radios" error={zahlweiseError !== ''}> bitte wählen</FormLabel>}
						</Typography>
						<FormControl component="fieldset">
							<RadioGroup
								aria-label="Zahlweise"
								className="epeZahlweiseState"
								name="zahlweise"
								value={zahlweiseState}
								onChange={handleChangeZahlweise}
								ref={zahlweiseRef}
							>
								< FormControlLabel
									value={Zahlweise.MB}
									control={<Radio color="primary" />}
									label="Monatsbeitrag"
									disabled={SalesType.EPH === props.contract.salesType}
								/>
								<FormControlLabel
									value={Zahlweise.EB}
									control={<Radio color="primary" />}
									label="Einmalbeitrag"
								/>
							</RadioGroup>
						</FormControl>
					</div>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle}>
							{t('epVehicle.section4_title')}
						</Typography>
						<FormControl component="fieldset">
							<RadioGroup
								aria-label="Produkte"
								className="epeProduktAuswahlState"
								name="produkte"
								value={produkt}
								onChange={handleChangeProdukte}
								ref={produktRef}
							>
								<FormControlLabel
									value={Produkt.EP}
									control={<Radio color="primary" />}
									label={Produkt['EP']}
								/>
								<FormControlLabel
									value={Produkt.EPP}
									control={<Radio color="primary" />}
									label={Produkt['EPP']}
								/>
							</RadioGroup>
						</FormControl>
					</div>
					<div className={classes.ep_vehicle_box}>
						<Typography variant="h3" className={classes.sectionTitle}>
							{t('epVehicle.section5_title')}
						</Typography>
						<div className={`${classes['.user_data_selector_wrapper']} ${classes['.user_data_input']}`}
						>
							<GenericSelect
								options={getLaufzeitValues}
								selectedValue={laufzeit?.toString()}
								setSelectedValue={ value  => {
									setLaufzeit(parseInt(value));
									revertButtonState();
								}}
								error={laufzeitError}
								placeholder={t('epVehicle.select')}
								dataCy="user_data_birth_day"
								className={`${classes['.ep_vehicle_laufzeit']}`}
								additionalInputParams={{
									inputRef: laufzeitRef,
									onInput: onSelectInput,
								}}
							/>
						</div>
					</div>
					<div className={classes.ep_vehicle_box}>
					<Typography variant="h3" className={classes.sectionTitle}>
						{t('epVehicle.section6_title')}
					</Typography>
					<SelectGroup>
						<SelectWrapper>
							<DateSelect
								selectedValue={versBeginDay}
								setSelectedValue={(value) => {
									setVersBeginDay(value);
									validateVersBeginDate({ day: value });
									revertButtonState();
								}}
								placeholder={t('common.date.day')}
								error={versBeginDayError}
								dataCy="versBegin_day"
								dateType="day"
								// defaultDate={moment().toDate()}
								additionalInputParams={{
									inputRef: versBeginDayRef,
									onInput: onSelectInput,
								}}
							/>
						</SelectWrapper>
						<SelectWrapper>
							<DateSelect
								selectedValue={versBeginMonth}
								setSelectedValue={(value) => {
									setVersBeginMonth(value);
									validateVersBeginDate({ month: value });
									revertButtonState();
								}}
								placeholder={t('common.date.month')}
								error={versBeginMonthError}
								dataCy="versBegin_month"
								dateType="month"
								// defaultDate={moment().toDate()}
								additionalInputParams={{
									inputRef: versBeginMonthRef,
									onInput: onSelectInput,
								}}
							/>
						</SelectWrapper>
						<SelectWrapper>
							<DateSelect
								selectedValue={versBeginYear}
								setSelectedValue={(value) => {
									setVersBeginYear(value);
									validateVersBeginDate({ year: value });
									revertButtonState();
								}}
								placeholder={t('common.date.year')}
								error={versBeginYearError}
								dataCy="versBegin_year"
								dateType="year"
								// defaultDate={moment().add(1, 'years').toDate()}
								additionalInputParams={{
									inputRef: versBeginYearRef,
									onInput: onSelectInput,
								}}
								onlyRange={true}
								addYear={true}
							/>
							</SelectWrapper>
					</SelectGroup>
					{!!versBeginDateError && (
						<div className={classes.errorMessage}>{versBeginDateError}</div>
					)}
				</div>
				</div>
			</div>
			<div className={classes.ep_vehicle_container_lastChild}>
				<NavigationBar onClickContinue={ !isCalculated ? handleCalc : validateAndSubmit }  {...{showPrice: isCalculated, price: beitrag}} />
			</div>
		</div>
	);
};
interface StateProps {
	contract: ContractState;
}

interface DispatchProps {
	collectedState: CollectedState;
	calculate(): Promise<Tariffing>;
}

const mapStateToProps = (state: AppState) => ({
	contract: state.contract,
	collectedState: state.collectedState,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({
	calculate: async () => dispatch(calculateContract()),
});

export const EpVehicle = connect(
	mapStateToProps,
	mapDispatchToProps
)(InternalepVehicle);
